export default __webpack_public_path__ + "static/media/Strangler's Straps of Waning Dusk.4e839973.jpg";